// Grid keyboard navigation utilities for the registration SampleEditor table.
//
// Handles Alt+Arrow navigation across the focused row/column based on
// `data-sample-grid-row` + `data-sample-grid-col` markers.
export function handleAltArrowGridNavigation({ event, root, closeActiveDatePicker }) {
  const e = event;
  if (!e || !e.altKey) return false;
  if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) return false;
  if (!root) return false;

  const activeEl = document.activeElement;
  if (!activeEl || !root.contains(activeEl)) return false;

  const fromEl = activeEl.closest(
    'input[data-sample-grid-col], select[data-sample-grid-col], textarea[data-sample-grid-col]'
  );
  if (!fromEl || !root.contains(fromEl)) return false;

  const currentRow = fromEl.closest('tr[data-sample-grid-row]');
  if (!currentRow) return false;

  // Prevent browser back/forward on Alt+Left/Right and keep navigation deterministic.
  e.preventDefault();
  e.stopPropagation();

  // Ensure any open datepicker is closed before we move focus.
  if (closeActiveDatePicker) closeActiveDatePicker();

  const isFocusable = (el) => {
    if (!el) return false;
    if (el.disabled) return false;
    if (el.getAttribute && el.getAttribute("type") === "hidden") return false;
    return true;
  };

  const focusablesInRow = (row) =>
    Array.from(
      row.querySelectorAll(
        'input[data-sample-grid-col], select[data-sample-grid-col], textarea[data-sample-grid-col]'
      )
    ).filter(isFocusable);

  const allRows = () => Array.from(root.querySelectorAll('tr[data-sample-grid-row]'));

  const focusEl = (el) => {
    if (!el) return;
    if (el.focus) el.focus();
  };

  if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
    const cells = focusablesInRow(currentRow);
    const idx = cells.indexOf(fromEl);
    if (idx === -1) return true;
    const nextIdx = e.key === "ArrowLeft" ? idx - 1 : idx + 1;
    const next = cells[nextIdx];
    if (!next) return true;
    focusEl(next);
    return true;
  }

  // Up/Down: keep the same column key, find the nearest row that has that key.
  const colKey = fromEl.getAttribute("data-sample-grid-col");
  if (!colKey) return true;

  const rows = allRows();
  const rowIdx = rows.indexOf(currentRow);
  if (rowIdx === -1) return true;

  const step = e.key === "ArrowUp" ? -1 : 1;
  for (let i = rowIdx + step; i >= 0 && i < rows.length; i += step) {
    const row = rows[i];
    const match = row.querySelector(
      `input[data-sample-grid-col="${colKey}"], select[data-sample-grid-col="${colKey}"], textarea[data-sample-grid-col="${colKey}"]`
    );
    if (isFocusable(match)) {
      focusEl(match);
      return true;
    }
  }

  return true;
}

